import { useMemo } from 'react';

import { getValidationI18n, getFilePickerProgressI18n } from '../utils';

export const useValidationI18n = i18n => useMemo(() => getValidationI18n(i18n), [i18n]);

export const useFilePickerProgressI18n = i18n => useMemo(() => getFilePickerProgressI18n(i18n), [i18n]);
